import { BaseModel } from '../../../models/base-model'
import { ICloneable } from '../../../core/models/cloneable.interface'
import { IMenuItemAction } from './menu-item-action.interface'

export class MenuItem extends BaseModel implements ICloneable<MenuItem> {
  private _action: IMenuItemAction
  public menuItems: MenuItem[]
  public title: string = ''
  public icon: string = ''
  public resourceId: number
  public styles: string[]

  constructor() {
    super()

    this._action = null
    this.menuItems = []
    this.styles = []
  }

  public isInvisible() {
    return typeof this.title !== 'string' || this.title.trim() === ''
  }

  public hasMenuItems() {
    return Array.isArray(this.menuItems) && this.menuItems.length > 0
  }

  public hasResource() {
    return typeof this.resourceId === 'number' || typeof this.resourceId === 'string'
  }

  public set action(action: IMenuItemAction) {
    this._action = action
  }

  public get action() {
    return this._action
  }

  public clone() {
    const dup = new MenuItem()
    let properties = ['id', 'title', 'icon', 'resourceId']
    properties.forEach((property) => dup[property] = this[property])
    properties = ['menuItems', 'styles']
    properties.forEach((property) => dup[property] = (this[property] || []).slice(0))
    return dup
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/menu-item/menu-item.ts